/**
 * Why getting a words-happen session failed, as the identity app acts on it. `network`, `server` and `stale` are
 * transient: trying again may work. The rest need the player to do something else.
 */
export type SessionFailure =
  | 'network'
  | 'server'
  | 'stale'
  | 'email-not-verified'
  | 'token-invalid'
  | 'origin-not-allowed'
  | 'unexpected';

const TRANSIENT: readonly SessionFailure[] = ['network', 'server', 'stale'];

export const isTransient = (failure: SessionFailure): boolean => TRANSIENT.includes(failure);

/** A failed session exchange or sign-out call; `failure` says why. Never carries a token. */
export class SessionError extends Error {
  constructor(readonly failure: SessionFailure) {
    super(`Session request failed: ${failure}`);
    this.name = 'SessionError';
  }
}

/** The failure behind any error from the session handoff: a SessionError's own, else a Firebase network error. */
export const sessionFailure = (error: unknown): SessionFailure => {
  if (error instanceof SessionError) {
    return error.failure;
  }
  return (error as { code?: unknown } | null)?.code === 'auth/network-request-failed' ? 'network' : 'unexpected';
};
